import { client } from "api";
import { Comment } from "models/Comment";

export type AddInternalCommentRequest = { message: string; listId: string };
export type AddInternalCommentResponse = Comment;

export const addInternalComment = (params: AddInternalCommentRequest) =>
  client.post<AddInternalCommentResponse>(`/checklist/internal`, params).then((res) => res.data);
